// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getReqAttributesApi } from "../../Service/Api/RequestAttributesApi"
import { getRegAttributesList,getErrors } from "../Reducer/RequestAttributesReducer"
 


// Watchers
function* reqAttributesListSaga() {
	yield takeEvery("reqAttributes_list/getReqAttributes", getAllReqAttributes)
}

// Sagas
function* getAllReqAttributes(action) {
	// console.log(action)
	try {
		const getReqAttributes = yield call(getReqAttributesApi, action.payload)
		// console.log(getCategories,"ldfgsdgb")

		if (getReqAttributes.request.status === 200) {
			yield put(getRegAttributesList(getReqAttributes))
		} else {
			yield put(getErrors(true))
		}
	} catch (error) {
		// console.log(error,"otp error")
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(reqAttributesListSaga)])
}
